// 14's settings registration — Workspace › Business Context, the weekly digest's optional context
// (v3 `BusinessContextSettings.vue`, tab value `weekly_digest`). 14 owns it because the data is the
// `weekly_digest` flow's profile override (`/workflow/flows/weekly_digest/profiles/…`), and because
// its KPI picker reads 08's metric catalog — an import module 22 is not allowed to make.
//
// A function, not a module side effect: `resetSettingsRegistry()` clears nav entries wholesale, so
// only a registration a test can re-run survives. `app/bootstrap.ts` hands the registrar in.
import type { RouteRecordRaw } from 'vue-router'

import { registerWorkflowMessages } from './i18n'

import type { SettingsNavEntry } from '@/features/workspace-settings'
import { useLocaleStore } from '@/shared/i18n'

export interface WorkflowSettingsRegistrar {
  registerNav: (entry: SettingsNavEntry) => void
  registerRoutes: (records: RouteRecordRaw[]) => void
}

export const BUSINESS_CONTEXT_NAV_KEY = 'workspace.businessContext'

export const workflowSettingsRoutes: RouteRecordRaw[] = [
  {
    path: 'workspace/business-context',
    name: 'SettingsBusinessContext',
    component: () => import('./components/businessContext/BusinessContextPane.vue'),
    meta: { titleKey: 'workflow.businessContext.title', navKey: BUSINESS_CONTEXT_NAV_KEY },
    beforeEnter: () => registerWorkflowMessages(useLocaleStore().locale),
  },
]

/**
 * Visible to everyone, as v3's tab was (`active: true`): a viewer reads the context the digest
 * runs with, and the pane degrades to read-only rather than hiding (contract 22 §12).
 */
export function installWorkflowSettings(reg: WorkflowSettingsRegistrar): void {
  reg.registerRoutes(workflowSettingsRoutes)
  reg.registerNav({
    key: BUSINESS_CONTEXT_NAV_KEY,
    labelKey: 'workflow.businessContext.navLabel',
    icon: 'gear',
    group: 'workspace',
    order: 70,
    routeName: 'SettingsBusinessContext',
    visible: () => true,
  })
}
